module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Oryginalne zdjęcie")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "file-upload-form"
  }, [_c('image-input-component', {
    attrs: {
      "value": _vm.photo
    },
    on: {
      "input": _vm.onImageChange
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.croppers), function(cropper) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.photo),
        expression: "photo"
      }],
      staticClass: "cropper-wrapper"
    }, [_c('strong', [_vm._v(_vm._s(cropper.label))]), _vm._v(" "), (_vm.errors && _vm.errors[cropper.paramsFieldName]) ? _c('p', {
      staticClass: "errors"
    }, [_vm._v("\n            " + _vm._s(_vm.errors[cropper.paramsFieldName]) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "id": cropper.id,
        "src": _vm.photo,
        "alt": ""
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c60f035"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoCropper.vue
// module id = 750
// module chunks = 0